import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "../store";
import timelineInterface from "./timelineInterface";
// Define a type for the slice state

// Define the initial state using that type

const timelineSlice = createSlice({
  name: "timeline",

  initialState: { timeline: [], timelineLoader: false },
  reducers: {
    timelineReducer: (
      state: any,
      action: PayloadAction<timelineInterface[]>
    ) => {
      state.timeline = action.payload;
    },
    timelineReducerLoader: (state: any, action: PayloadAction<any>) => {
      state.timelineLoader = action.payload;
    },
    resetTimeline: (state: any) => {
      state.timeline = "";
    },
  },
});

export const { timelineReducer, resetTimeline, timelineReducerLoader } =
  timelineSlice.actions;

// // Other code such as selectors can use the imported `RootState` type
// export const selectCount = (state: RootState) => state.counter.value

export default timelineSlice.reducer;
